import types from '../constants/types'

export const commonMutation = {
  [types.COMMON_REQUEST] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = true
    state[action.request]['didInvalidate'] = false
  },
  [types.COMMON_SUCCESS] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['didInvalidate'] = false
    state[action.request]['data'] = action.data.data || action.data.info
    state[action.request]['lastUpdated'] = (new Date()).getTime()
  },
  [types.COMMON_FAILURE] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['data'] = action.data.data || action.data.info
    state[action.request]['didInvalidate'] = true
  },
  [types.COMMON_INIT] (state, action) {
    state[action.request] = {...state[action.request]}
    state[action.request]['isPosting'] = false
    state[action.request]['didInvalidate'] = false
  }
}
